import { render, staticRenderFns } from "./dicDialog.vue?vue&type=template&id=85ec14b6&"
import script from "./dicDialog.vue?vue&type=script&lang=js&"
export * from "./dicDialog.vue?vue&type=script&lang=js&"
import style0 from "./dicDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports